// 预约挂号——皖事通，主流程
const wstMainRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `register/wst/index${i + 1}`,
  name: `registerWstIndex${i + 1}`,
  component: () => import(`@/views/health/register/wst/index${i + 1}.vue`),
}));


export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    // 预约挂号——皖事通，主流程
    ...wstMainRoutes,
  ],
};
